const INVOICE_TIME_ZONE = 'America/Los_Angeles';
const INVOICE_LOCALE = 'en-US';

const invoiceDateFormatter = new Intl.DateTimeFormat(INVOICE_LOCALE, {
	timeZone: INVOICE_TIME_ZONE,
	year: 'numeric',
	month: '2-digit',
	day: '2-digit'
});

const invoiceDateTimeFormatter = new Intl.DateTimeFormat(INVOICE_LOCALE, {
	timeZone: INVOICE_TIME_ZONE,
	year: '2-digit',
	month: 'numeric',
	day: 'numeric',
	hour: 'numeric',
	minute: '2-digit'
});

function parseDate(dateValue?: string): Date | null {
	if (!dateValue) {
		return null;
	}

	const parsedDate = new Date(dateValue);
	return isNaN(parsedDate.getTime()) ? null : parsedDate;
}

export function formatInvoiceDate(dateValue?: string): string {
	const parsedDate = parseDate(dateValue);
	if (!parsedDate) {
		return '—';
	}

	return invoiceDateFormatter.format(parsedDate);
}

export function formatInvoiceDateTime(dateValue?: string): string {
	const parsedDate = parseDate(dateValue);
	if (!parsedDate) {
		return '—';
	}

	return invoiceDateTimeFormatter.format(parsedDate);
}
